import React, { lazy } from 'react';
export function BeforeAfterAction() {
  return <section className="bg-warm-mid py-16 md:py-20 px-4" data-id="element-20">
      <div className="max-w-4xl mx-auto" data-id="element-21">
        {/* Section label */}
        <p className="font-sans font-medium text-soft-gold uppercase tracking-wider text-xs md:text-sm text-center mb-3" data-id="element-22">
          Yes — even action shots can look better
        </p>

        {/* Before / After Image Comparison */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8" data-id="element-23">
          {/* Before */}
          <div className="relative rounded-2xl overflow-hidden shadow-lg" data-id="element-24">
            <img src="https://cdn.magicpatterns.com/uploads/nRBMbVePXaGqBfQ1GMafef/ChatGPT_Image_Mar_20,_2026,_05_33_55_PM.png" alt="Before: Border collie running with less polished framing and timing" className="w-full h-64 md:h-80 object-cover" loading="lazy" decoding="async" width={672} height={448} data-id="element-25" />
            <div className="absolute top-3 left-3 bg-red-500/90 text-white font-sans font-bold text-xs uppercase tracking-wider px-3 py-1.5 rounded-full" data-id="element-26">
              Before
            </div>
          </div>

          {/* After */}
          <div className="relative rounded-2xl overflow-hidden shadow-xl ring-2 ring-soft-gold/30" data-id="element-27">
            <img src="https://cdn.magicpatterns.com/uploads/w2QuU2mWNtG5D14zRNcMzj/ChatGPT_Image_Mar_20,_2026,_05_37_01_PM.png" alt="After: Border collie running with better timing, warm golden hour lighting and sharp composition" className="w-full h-64 md:h-80 object-cover" loading="lazy" decoding="async" width={672} height={448} data-id="element-28" />
            <div className="absolute top-3 left-3 bg-green-600/90 text-white font-sans font-bold text-xs uppercase tracking-wider px-3 py-1.5 rounded-full" data-id="element-29">
              After
            </div>
          </div>
        </div>

        {/* Text below */}
        <p className="font-sans text-lg md:text-xl text-gray-800 text-center max-w-2xl mx-auto leading-relaxed" data-id="element-30">
          You do not need luck to capture movement well. You need{' '}
          <span className="font-semibold text-warm-hero" data-id="element-31">
            a simple system that helps you time, frame, and guide the shot
            better.
          </span>
        </p>
      </div>
    </section>;
}